import { useIntl } from 'react-intl';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconX } from '#src/atoms/icons/system/iconX.ts';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  onClose: () => void;
  transparent?: boolean;
  className?: string;
};

export const CloseButton = ({ onClose, transparent, className }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Button
      size="medium"
      onClick={onClose}
      startIcon={<FontAwesomeIcon icon={iconX} />}
      color={transparent ? 'transparent' : 'tertiary'}
      aria-label={formatMessage(glossary.close)}
      className={className}
    />
  );
};
